import { Box, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../../../utils/icons"
import { useGoBackToListStyles } from "./goBackToListStyles"
import { useNavigate } from "react-router-dom"

const GoBackToList = ({ exit }: { exit?: boolean }) => {
    const { t } = useTranslation()
    const styles = useGoBackToListStyles()
    const navigate = useNavigate();

    return (
        <Box sx={styles.flex}>
            <IconButton
                sx={styles.goBack}
                onClick={() => {
                    navigate("/dashboard/report-folio/dashboard")
                }}
            >
                {icons('arrow-left-fill')}
            </IconButton>

            <Typography sx={styles.goBackText}>{t('general.goBackToTheList')}</Typography>
        </Box>
    )
}


export { GoBackToList }